import { ContentType } from "./http-client";

export class Approvals {
  constructor(http) {
    this.http = http;
  }

  requestApproval = (payload) =>
    this.http.request({
      path: "/api/core/approvals",
      method: "POST",
      body: payload,
      type: ContentType.Json,
      secure: true,
    });

  listForEntity = (entityType, entityId) =>
    this.http.request({
      path: `/api/core/approvals/entity/${entityType}/${entityId}`,
      method: "GET",
      secure: true,
    });

  listPending = (assigneeId) =>
    this.http.request({
      path: "/api/core/approvals/pending",
      method: "GET",
      query: assigneeId ? { assigneeId } : undefined,
      secure: true,
    });

  list = (params = {}) =>
    this.http.request({
      path: "/api/core/approvals",
      method: "GET",
      query: params,
      secure: true,
    });

  get = (approvalId) =>
    this.http.request({
      path: `/api/core/approvals/${approvalId}`,
      method: "GET",
      secure: true,
    });

  approve = (approvalId, payload = {}) =>
    this.http.request({
      path: `/api/core/approvals/${approvalId}/approve`,
      method: "POST",
      body: payload,
      type: ContentType.Json,
      secure: true,
    });

  reject = (approvalId, payload = {}) =>
    this.http.request({
      path: `/api/core/approvals/${approvalId}/reject`,
      method: "POST",
      body: payload,
      type: ContentType.Json,
      secure: true,
    });

  cancel = (approvalId, payload = {}) =>
    this.http.request({
      path: `/api/core/approvals/${approvalId}/cancel`,
      method: "POST",
      body: payload,
      type: ContentType.Json,
      secure: true,
    });
}
